import * as Yup from "yup"
import { Campus, Email, FirstName, LastName } from "services/validation"


const schema = Yup.object().shape({
  lead: Yup.object().shape({
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
  })
})

export default schema
